import React from 'react';
import Swal from 'sweetalert2';

import { Board } from 'types';
import { store } from 'redux/store';
import { TranslateFn } from 'hooks/useTranslate';

import instructionTypes from 'constants/instructionTypes';
import { SELECCIONAR_SOCIO } from 'constants/defaultConstants';

import { setModal } from 'modules/_shared/redux/modalActions';
import { updateBoard } from 'modules/boards/redux/boardActions';

type SaveDelegationParams = {
  actualSociety: any;
  board: Board;
  event: React.FormEvent;
  hasInstructions: boolean;
  instructions: any[];
  instructionType: string;
  onLoading: (loading: boolean) => void; // eslint-disable-line no-unused-vars
  partnerId: string;
  selectedPartner: string;
  t: TranslateFn;
};

export const saveDelegation = async ({
  event,
  selectedPartner,
  board,
  partnerId,
  instructionType,
  instructions,
  hasInstructions,
  t,
  onLoading,
  actualSociety,
}: SaveDelegationParams) => {
  event.preventDefault();

  if (selectedPartner !== SELECCIONAR_SOCIO) {
    const participant = board?.participants?.find(
      (p) => p?.member === partnerId
    );

    if (participant) {
      const representative = board?.participants.find(
        (p) => p?.member === selectedPartner
      );

      if (representative?.assists) {
        participant.assists = true;
        participant.isAbsent = false;
      } else if (representative?.isAbsent) {
        participant.assists = false;
        participant.isAbsent = true;
      }

      participant.isRepresented = true;
      participant.representative = selectedPartner;

      const newInstructions =
        instructionType === instructionTypes.POINT_BY_POINT.value
          ? instructions
          : [];

      participant.delegationVote = hasInstructions
        ? { instructionType, instructions: newInstructions }
        : null;

      // TODO: Validate if newParticipants is needed, looks like old implementation
      // const newParticipants = board?.participants.map((p) =>
      //   p?.member === participant?.member ? participant : p
      // );

      return Swal.fire({
        icon: 'info',
        title: `<h4 class="nk-modal-title">${t('Attention')}<br></h4>`,
        html: `<p>${t('SignDocumentToComplete')}`,
        confirmButtonText: t('Sign'),
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonColor: '#6576FF',
      }).then(async (result) => {
        if (result.isConfirmed) {
          onLoading(true);

          await store.dispatch(
            updateBoard(board['_id'], { participantData: participant }, false)
          );

          await store.dispatch(setModal(null));

          onLoading(false);
          window.location.href = `#/firma-delegacion/${actualSociety['_id']}/${board['_id']}/${partnerId}`;
        }
      });
    }
  }
};
